import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../../components/Sidebar/Sidebar";
import ModalsLayout from "./ModalsLayout";
import { useListenerManager } from "../../services/ListenerManager/useListenerManager";
import { useChatMetadataListeners } from "../../services/ListenerManager/useChatMetadataListeners";
import UserAuthStore from "../../store/userStore";


const AppLayout = () => {
  const user = UserAuthStore((state) => state.user);
  const orgId = UserAuthStore((state) => state.orgId);

  // Initialize global listeners
  useListenerManager(user, orgId);
  
  // Initialize chat metadata listeners (always-on)
  useChatMetadataListeners();

  return (
    <main
      className={`flex w-screen h-[100dvh] dark:text-ink-gray-100 bg-surface-page`}
    >
      <Sidebar />
      <Outlet />
      <ModalsLayout />
    </main>
  );
};

export default AppLayout;
